//TODO check why it doesnt work properly
function Preloader() {
  return (
    <div id="preloader">
      <div className="spinner">
        <div className="bounce1"></div>
      </div>
    </div>
  );
}
export default Preloader;
